let articleGridFilter = {};

articleGridFilter.dropdown = function() {
    var $articleDropdown = $('.article-dropdown .article-dropdown-title');
    var $articleContent = $('.article-dropdown .article-dropdown-menu');

    $articleDropdown.click(function() {
        var thisDropdown = $(this);

        if (thisDropdown.next('.article-dropdown-menu').hasClass('show')) {
            thisDropdown.next('.article-dropdown-menu').removeClass('show');
        } else {
            $articleContent.removeClass('show');
            thisDropdown.next('.article-dropdown-menu').addClass('show');
        }
    });

    window.onclick = function(event) {
      if (!event.target.matches('.article-dropdown-title')) {
        var dropdowns = document.getElementsByClassName('article-dropdown-menu');
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    }
  };

  articleGridFilter.dropdown();


// WEBPACK FOOTER //
// ./scripts/util/articleFilter.js